import React from 'react';
import { Loader as LoaderKendo } from '@progress/kendo-react-indicators';
import { useTranslation } from '@hooks/index';

const Loader = () => {
    const { t } = useTranslation();

    return (
        <div className="k-d-flex k-align-items-center">
            <span className="k-mr-1" style={{ fontSize: 12 }}>
                {t('gridLoading')}
            </span>
            <LoaderKendo size="small" type="pulsing" />
        </div>
    );
};

export default Loader;
